import { render, staticRenderFns } from "./SchedulerGridFooter.vue?vue&type=template&id=08ab64c2&"
import script from "./SchedulerGridFooter.vue?vue&type=script&lang=js&"
export * from "./SchedulerGridFooter.vue?vue&type=script&lang=js&"
import style0 from "./SchedulerGridFooter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports